import { useLanguage } from '../context/LanguageContext';

export const LanguageSwitcher = ({ className = '' }) => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <button
      onClick={toggleLanguage}
      className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium transition-all duration-200 ${className}`}
      style={{ color: '#6b6b6b' }}
      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#eeeeee'}
      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
      data-testid="language-switcher"
      aria-label={`Switch to ${language === 'en' ? 'Swedish' : 'English'}`}
    >
      <span style={{ color: language === 'en' ? '#1c8a56' : '#6b6b6b', fontWeight: language === 'en' ? 600 : 400 }}>EN</span>
      <span style={{ color: '#e5e5e5' }}>|</span>
      <span style={{ color: language === 'sv' ? '#1c8a56' : '#6b6b6b', fontWeight: language === 'sv' ? 600 : 400 }}>SV</span>
    </button>
  );
};
